<template>
  <div class="newindex">
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="(item, index) in banners" :key="index">
        <img
          :src="item.imgUrl"
          alt=""
          class="banner_img"
          @click="tolink(item)"
        />
      </van-swipe-item>
    </van-swipe>
    <div class="card">
      <van-image :src="info.avatarPath | getavatar" class="avar" >
        <template v-slot:error>
          <img src="../../assets/img/avater.png" class="avar" style="margin-right:0">
        </template>
      </van-image>
      <!-- <img :src="" /> -->
      <div class="flex aic">
        <div class="w241">
          <div class="title">{{ info.nickName }}</div>
          <div class="desc">手机：{{ info.phone }}</div>
          <div class="desc" v-if="info.employeeNumber">
            工号：{{ info.employeeNumber ? info.employeeNumber : "无" }}
          </div>
        </div>
        <router-link to="/card" class="setcard">设置名片</router-link>
      </div>
    </div>
    <div class="flex jc-sb mt-15  mb-25 outside" style="flex-wrap: wrap">
      <div
        class="block"
        v-for="(item, index) in list"
        :key="index"
        @click="toroute(item, index)"
      >
        <div class="pic">
          <img :src="item.img" alt="" />
        </div>
        <div class="title">{{ item.title }}</div>
        <div class="desc">{{ item.desc }}</div>
      </div>
    </div>
    <div class="out" @click="loginout">退出登录</div>
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from "@/components/Newfooter";
import { userinfo, getcarousel, logout } from "../../api/apis";
import { removeToken } from "@/utils/auth";
export default {
  components: {
    Footer,
  },
  data() {
    return {
      banners: [],
      list: [
        {
          img: require("../../assets/img/mingpian.png"),
          title: "我的名片",
          desc: "展示不一样的自己",
          url: "/usercard",
        },
        // {
        //   img: require("../../assets/img/client/ruzhi.png"),
        //   title: "在线入职",
        //   desc: "加入中联信",
        //   url: "https://zlx-wxapp.zrbxyun.com/#!/app/mine/invite",
        // },
        {
          img: require("../../assets/img/haibao.png"),
          title: "获客海报",
          desc: "精美海报 一键生成 ",
          url: "/poster",
        },
        {
          img: require("../../assets/img/wenchang.png"),
          title: "获客文章",
          desc: "专业文章，快速引流",
          url: "/article",
        },
        {
          img: require("../../assets/img/chanpin.png"),
          title: "产品知识库",
          desc: "在销产品知识汇总",
          url: "/allprod",
        },
        {
          img: require("../../assets/img/qiye.png"),
          title: "中联信学院",
          desc: "个人成长 快速提升",
          url: "/index",
        },
        {
          img: require("../../assets/img/baoxian.png"),
          title: "网销产品投保",
          desc: "互联网销售保险产品投保入口",
          url: "/prolist",
        },

        {
          img: require("../../assets/img/client/chudan.png"),
          title: "线下产品投保",
          desc: "百年人寿、信泰人寿投保入口",
          url: "https://zlx-wxapp.zrbxyun.com/#!/app/tab/home",
        },
        // {
        //   img: require("../../assets/img/client/gaozhishu.png"),
        //   title: "客户告知书",
        //   desc: "管理我的告知书",
        //   url: "/notice",
        // },
      ],
      info: {},
    };
  },
  methods: {
    toroute(item, inx) {
      // if (item.title == '我的名片'||inx=='客户告知书') {
      //   let url = item.url + "?userId=" + this.info.id;
      //   this.$router.push({ path: url });
      // } else if (item.title == "在线入职" || item.title == "线下产品投保")
      // window.location.href = item.url;
      // else this.$router.push({ path: item.url });
      if (item.url.indexOf('http') != -1) {
        window.location.href = item.url;
      } else {
        let url = item.url + "?userId=" + this.info.id;
        this.$router.push({ path: url });
      }

    },
    getinfo() {
      userinfo().then((res) => {
        this.info = res;
        if (!this.$store.state.user.user.user) {
          this.$store.commit("SET_USER", { user: res });
        }
        console.log(this.$store.state.user.user);
      });
    },
    carousel() {
      let data = {
        enabled: 1,
        sort: "id,desc",
        page: 0,
        size: 99,
      };
      getcarousel(data).then((res) => {
        this.banners = res.content;
      });
    },
    tolink(item) {
      console.log(item);
      if (!item.link) return;
      if (item.type == "Link") {
        window.location.href = item.link;
      } else if (item.type == "Article") {
        this.$router.push({
          path: "/articledetail",
          query: { userId: this.info.id, articleId: item.link },
        });
      } else if (item.type == "Course") {
        this.$router.push({
          path: "/courseDetail",
          query: { courseId: item.link },
        });
      } else {
        this.$router.push({ path: "/prodetail", query: { id: item.link } });
      }
    },
    loginout() {
      logout().then((res) => {
        removeToken();
        this.$router.push({ path: "/" });
      });
    },
  },
  mounted() {
    this.getinfo();
    this.carousel();
  },
};
</script>
<style lang="less" scoped>
.newindex {
  width: 100%;
  padding-bottom: 50px;
  .my-swipe {
    width: 358px;
    height: 168px;
    margin: 6px auto 0;
    border-radius: 3px;
    overflow: hidden;
    .banner_img {
      width: 100%;
      height: 100%;
      border-radius: 3px;
    }
  }
  .card {
    width: 358px;
    height: 85px;
    margin: 15px auto 0;
    border-radius: 2px;
    text-align: left;
    background: #fff;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(255, 255, 255, 100);
    padding: 10px 18px 0 15px;
    box-sizing: border-box;
    display: flex;
    .title {
      width: 100%;
      font-size: 18px;
      color: rgba(16, 16, 16, 100);
      font-family: SourceHanSansSC-regular;
      line-height: 27px;
    }
    .desc {
      color: rgba(80, 85, 89, 100);
      font-size: 10px;
      text-align: left;
      line-height: 15px;
      font-family: SourceHanSansSC-regular;
    }
    .avar {
      width: 63px;
      height: 63px;
      border-radius: 3px;
      margin-right: 20px;
    }
    .setcard {
      width: 74px;
      height: 25px;
      line-height: 25px;
      border-radius: 4px;
      color: rgba(93, 199, 185, 100);
      font-size: 11px;
      text-align: center;
      font-family: Roboto;
      border: 1px solid rgba(93, 199, 185, 100);
    }
  }
  .block {
    width: 172px;
    height: 122px;
    line-height: 10px;
    border-radius: 3px;
    text-align: center;
    border: 1px solid rgba(255, 255, 255, 100);
    background: #fff;
    margin-top: 11px;
    padding-left: 18px;
    padding-top: 13px;
    box-sizing: border-box;
    .pic {
      width: 34px;
      height: 34px;
      line-height: 34px;
      border-radius: 100px;
      background-color: rgba(93, 199, 185, 0.23);
      text-align: center;
      border: 1px solid rgba(255, 255, 255, 100);
      // margin-top:13px ;
      // margin-left: 18px;
      img {
        width: 19px;
        height: 19px;
        margin-top: 7px;
      }
    }
    .title {
      color: rgba(26, 44, 59, 100);
      font-size: 15px;
      text-align: left;
      line-height: 22px;
      font-family: SourceHanSansSC-bold;
      margin-top: 9px;
    }
    .desc {
      color: rgba(153, 159, 164, 100);
      font-size: 11px;
      text-align: left;
      line-height: 16px;
      margin-top: 7px;
      font-family: SourceHanSansSC-bold;
    }
  }
  .w241 {
    width: 164px;
  }
  .outside {
    width: 375px;
    padding-left: 9px;
    padding-right: 9px;
    box-sizing: border-box;
  }
  .out {
    width: 358px;
    height: 47px;
    line-height: 46px;
    border-radius: 24px;
    // background-color: rgba(255, 255, 255, 100);
    color: rgba(93, 199, 185, 100);
    font-size: 16px;
    text-align: center;
    font-family: Roboto;
    border: 1px solid rgba(93, 199, 185, 100);
    text-align: center;
    margin: 0 auto 50px;
  }
}
</style>